export default __webpack_public_path__ + "static/media/done2.c2ae23ed.svg";